<template>
  <div>
    <vx-tooltip
      :text="tooltip || $t('components.daterangepicker.tooltipDefault')"
      :position="positionTooltip"
      :isShow="isShow"
    >
      <div :class="vDaterangepickerClassName">
        <div class="vs-con-input">
          <label
            v-if="label"
            for="reportrange"
            class="v-daterangepicker__label vs-input--label pl-0"
            >{{ label }}</label
          >

          <span class="inline-block relative w-full">
            <input
              type="text"
              autocomplete="off"
              id="reportrange"
              class="v-daterangepicker__input vs-inputx vs-input--input normal w-full"
              :disabled="disabled"
            />

            <svg
              v-if="isDateIcon"
              class="v-daterangepicker__icon"
              width="14"
              height="16"
              viewBox="0 0 14 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M11.6666 2H10.3333V1.33333C10.3333 0.933331 10.0666 0.666664 9.66665 0.666664C9.26665 0.666664 8.99998 0.933331 8.99998 1.33333V2H4.99998V1.33333C4.99998 0.933331 4.73331 0.666664 4.33331 0.666664C3.93331 0.666664 3.66665 0.933331 3.66665 1.33333V2H2.33331C1.19998 2 0.333313 2.86666 0.333313 4V13.3333C0.333313 14.4667 1.19998 15.3333 2.33331 15.3333H11.6666C12.8 15.3333 13.6666 14.4667 13.6666 13.3333V4C13.6666 2.86666 12.8 2 11.6666 2ZM2.33331 3.33333H3.66665V4C3.66665 4.4 3.93331 4.66666 4.33331 4.66666C4.73331 4.66666 4.99998 4.4 4.99998 4V3.33333H8.99998V4C8.99998 4.4 9.26665 4.66666 9.66665 4.66666C10.0666 4.66666 10.3333 4.4 10.3333 4V3.33333H11.6666C12.0666 3.33333 12.3333 3.6 12.3333 4V6H1.66665V4C1.66665 3.6 1.93331 3.33333 2.33331 3.33333ZM2.33331 14H11.6666C12.0666 14 12.3333 13.7333 12.3333 13.3333V7.33333H1.66665V13.3333C1.66665 13.7333 1.93331 14 2.33331 14Z"
                fill="black"
              />
            </svg>
          </span>
        </div>
      </div>
    </vx-tooltip>
  </div>
</template>

<script>
import moment from "moment/moment.js";
import "daterangepicker/daterangepicker.js";
import "daterangepicker/daterangepicker.css";
import VxTooltip from "../../Tooltip/VxTooltip.vue";

export default {
  components: {
    VxTooltip,
  },
  props: {
    id: String,
    start: String,
    end: String,
    disabled: Boolean,
    label: String,
    startDate: String,
    endDate: String,
    /**
     * [Documentation: https://www.daterangepicker.com/#options]: maxSpan property
     */
    maxSpan: {
      type: Object,
      default: () => ({}),
    },
    /**
     * Tooltip description about date range
     */
    tooltip: String,

    isInside: {
      type: Boolean,
      default: false,
    },

    isDateIcon: {
      type: Boolean,
      default: false,
    },

    singleDatePicker: Boolean,
    showDropdowns: Boolean,
    showCustomRangeLabel: {
      type: Boolean,
      default: false,
    },
    alwaysShowCalendars: {
      type: Boolean,
      default: true,
    },
    isShow: {
      type: Boolean,
      default: true,
    },
    positionTooltip: {
      type: String,
      default: "bottom",
    },
  },

  mounted() {
    this.initPicker();
    this.$root.$on("updateI18n", () => {
      this.initPicker();
    });

    this._autoUpdateInput = this.autoUpdateInput;
  },
  methods: {
    initPicker() {
      let start = moment();
      let end = moment();

      if (this.start) {
        start = moment(this.start, "DD.MM.YYYY");
      }
      if (this.end) {
        end = moment(this.end, "DD.MM.YYYY");
      }

      // Maximum betweens start date and end date
      const maxSpan = this.maxSpan;

      $("#reportrange").daterangepicker(
        {
          startDate: this.startDate || start,
          endDate: this.endDate || end,
          alwaysShowCalendars: this.alwaysShowCalendars,
          showCustomRangeLabel: this.showCustomRangeLabel,
          locale: {
            format: "DD/MM/YYYY",
          },
          maxSpan: maxSpan,
          ranges: this.ranges,
          singleDatePicker: this.singleDatePicker,
          showDropdowns: this.showDropdowns,
          autoUpdateInput: true,
          maxDate: moment(),
        },
        (start, end) => {
          this.$emit(
            "input",
            start.format("DD.MM.YYYY"),
            end.format("DD.MM.YYYY")
          );
          this.$emit(
            "onChange",
            start.format("DD.MM.YYYY"),
            end.format("DD.MM.YYYY")
          );
        }
      );

      this.offEventFocusDateRangePicker();
    },

    offEventFocusDateRangePicker() {
      $("#reportrange").off("focus.daterangepicker");
    },
  },
  computed: {
    ranges() {
      let ranges = {};
      (ranges[this.$t("daterangepicker.today")] = [moment(), moment()]),
        (ranges[this.$t("daterangepicker.yesterday")] = [
          moment().subtract(1, "days"),
          moment().subtract(1, "days"),
        ]);
      ranges[this.$t("daterangepicker.last7days")] = [
        moment().subtract(6, "days"),
        moment(),
      ];
      ranges[this.$t("daterangepicker.last30days")] = [
        moment().subtract(29, "days"),
        moment(),
      ];
      ranges[this.$t("daterangepicker.thisMonth")] = [
        moment().startOf("month"),
        moment().endOf("month"),
      ];
      ranges[this.$t("daterangepicker.lastMonth")] = [
        moment().subtract(1, "month").startOf("month"),
        moment().subtract(1, "month").endOf("month"),
      ];
      ranges[this.$t("daterangepicker.thisQuarter")] = [
        moment().startOf("quarter"),
        moment().endOf("quarter").startOf("day"),
      ];
      ranges[this.$t("daterangepicker.lastQuarter")] = [
        moment().startOf("quarter").subtract(1, "quarters"),
        moment()
          .startOf("quarter")
          .subtract(1, "quarters")
          .endOf("quarter")
          .startOf("day"),
      ];
      return ranges;
    },
    vDaterangepickerClassName() {
      return {
        "v-daterangepicker vs-component vs-con-input-label vs-input vs-input-primary w-full": true,
        "v-daterangepicker--inside": this.isInside,
        "v-daterangepicker--hasIcon": this.isDateIcon,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.v-daterangepicker {
  .v-daterangepicker__label {
    font-size: 13px;
  }

  .v-daterangepicker__input {
  }

  .v-daterangepicker__icon {
    path {
      fill: var(--vs-hex-primary);
    }
  }

  &.v-daterangepicker--inside {
    position: relative;

    .v-daterangepicker__label {
      position: absolute;
      top: 50%;
      left: 15px;
      z-index: 100;
      transform: translateY(-50%);
    }

    .v-daterangepicker__input {
      padding-left: 120px !important;
    }
  }

  &.v-daterangepicker--hasIcon {
    position: relative;

    .v-daterangepicker__input {
      padding-right: 35px !important;
    }

    .v-daterangepicker__icon {
      position: absolute;
      top: 50%;
      right: 15px;
      transform: translateY(-50%);
    }
  }

  &:not(.v-daterangepicker--hasIcon, .v-daterangepicker--inside) {
    min-width: 200px;

    // .v-daterangepicker__input {
    //     text-align: center;
    // }
  }

  &.v-daterangepicker--inside:not(.v-daterangepicker--hasIcon) {
    min-width: 300px;
  }

  &.v-daterangepicker--hasIcon:not(.v-daterangepicker--inside) {
    min-width: 220px;
  }

  &.v-daterangepicker--inside.v-daterangepicker--inside {
    min-width: 320px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/report/order/daterangepicker.vue